import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Unauthorized() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const product = user?.product || process.env.REACT_APP_PRODUCT || "stroke";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
        textAlign="center"
        px={3}
      >
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="5rem"
          height="5rem"
          variant="gradient"
          bgColor="warning"
          color="white"
          shadow="md"
          borderRadius="xl"
          mb={3}
        >
          <Icon fontSize="large" color="inherit">lock</Icon>
        </MDBox>

        <MDTypography variant="h4" fontWeight="bold" mb={1}>
          Not Available
        </MDTypography>

        <MDTypography variant="body2" color="text" mb={1}>
          This page is not part of the <strong>{product}</strong> product.
        </MDTypography>

        <MDTypography variant="body2" color="text" mb={3}>
          Please contact BrainBerry if you believe you should have access.
        </MDTypography>

        <MDButton
          variant="gradient"
          color="dark"
          onClick={() => navigate("/pages/dashboard")}
        >
          <Icon sx={{ mr: 1 }}>arrow_back</Icon>
          Back to Dashboard
        </MDButton>
      </MDBox>
    </DashboardLayout>
  );
}
